import { useCallback } from "react";
import Button, { EButtonColor, EButtonVariant } from "components/elements/Button";
import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";
import { useUserSubscription } from "hooks/useUserSubscription";

type IProps = {
	fullwidth?: boolean;
	className?: string;
};

export default function UpgradeToProButton(props: IProps) {
	const { isUserSubscribed } = useUserSubscription();

	const navigateToSubscribePage = useCallback(() => {
		window.open("https://www.clapaction.com/espace-pro-createurs#contact-pro");
	}, []);

	return (
		!isUserSubscribed && (
			<Button variant={EButtonVariant.CONTAINED} color={EButtonColor.PRIMARY} onClick={navigateToSubscribePage} fullwidth={props.fullwidth} className={props.className}>
				<Typography type="p" size="medium" weight="medium">
					{I18n.asset.users.subscription.subscribe}
				</Typography>
			</Button>
		)
	);
}
